import { trapFocus } from "./vendor/trapFocus.js";

const bodyElement = document.querySelector('body');
const mainMenuToggle = document.querySelector('.js-main-menu-toggle');
const mainMenuToggleLabel = document.querySelector('.js-main-menu-toggle-label');
const mainMenu = document.querySelector('.js-main-menu');
const headerFocusableWrappers = document.querySelectorAll('.js-trap-focus');
let isMenuShown = false;

if (mainMenuToggle) {
    mainMenuToggle.addEventListener('click', function () {
        toggleMenuVisibility(!isMenuShown);
    });
}

function toggleMenuVisibility(value) {
    isMenuShown = value;
    bodyElement.classList.toggle('state--nav-open', value);
    mainMenuToggleLabel.textContent = (value ? 'Close' : 'Menu');
    mainMenuToggle.setAttribute("aria-expanded", value);
    mainMenu.classList.toggle('is-open', value);
    trapFocus(headerFocusableWrappers, value ? mainMenuToggle : null);
}

export { toggleMenuVisibility };
